<template lang="html">
  <div class="" @drop="onDrop($event)" @dragover.prevent @dragenter.prevent>
    <div v-for="(item, index) in tempItems" :key="index" draggable="true" @dragstart.stop="onDragStart($event)" @dragenter.stop="onDragEnter($event)">
      <slot name="item" v-bind:item="item" v-bind:index="index"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ['items'],
  data: function () {
    return {
      recompute: false,
      source: null,
      payload: {
    		oldIndex: -1,
    		newIndex: -1
    	}
    };
  },
  computed: {
    tempItems: function () {
      if (this.recompute) {
        this.$nextTick(() => this.recompute = false);
      }
      return this.recompute ? [] : this.items;
    }
  },
  methods: {
    onDrop: function (event) {
      console.log('onDrop', event);
      var movedItem = this.items.splice(this.payload.oldIndex, 1)[0];
      this.items.splice(this.payload.newIndex, 0, movedItem);
      this.recompute = true;
      this.$emit('change', this.payload);
    },
    onDragStart: function (event) {
      this.source = event.target;
			this.payload.oldIndex = this.getIndex(event.target);
			event.dataTransfer.effectAllowed = 'move';
    },
    onDragEnter: function (event) {
      var newIndexEl = event.target.parentNode;
			if (this.source.parentNode == newIndexEl.parentNode) {
				this.payload.newIndex = this.getIndex(newIndexEl);
				if (this.isBefore(this.source, newIndexEl)) {
					newIndexEl.parentNode.insertBefore(this.source, newIndexEl);
				} else {
					newIndexEl.parentNode.insertBefore(this.source, newIndexEl.nextSibling);
				}
			}
		},
    getIndex: function (a) {
  		var nodes = a.parentNode.children;
  		for (var i = 0; i < nodes.length; i++) {
  			if (nodes[i] === a) {
  				return i;
  			}
  		}
  		return -1;
  	},
    isBefore: function (a, b) {
  		if (a.parentNode == b.parentNode) {
  			for (var cur = a; cur; cur = cur.previousSibling) {
  				if (cur === b) {
  					return true;
  				}
  			}
  		}
  		return false;
  	}
  }
}
</script>

<style lang="css" scoped>
</style>
